var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuietZone = function SvgQuietZone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M3.529 3.529C.305 6.753-.257 11.629 1.84 15.43l-.86 3.583a1 1 0 0 0 1.206 1.206l3.582-.86c3.801 2.098 8.678 1.536 11.902-1.688M.6.6l20 20m-.688-6.347a10 10 0 0 0-2.24-10.724 10 10 0 0 0-10.725-2.24"
  })));
};
export default SvgQuietZone;